const validateErrorCode = (errorCode = {}) => {
    const {
        id,
        category,
        status,
    } = errorCode;

    const isValid = Boolean(
        id &&
        category &&
        status
    );

    if (!isValid) {
        throw new TypeError('CONSUMER_ERROR_PAYLOAD_INVALID_SCHEMA');
    } else {
        return errorCode;
    }
};

class ConsumerErrorPayload {
    constructor(errorCode, stackTrace) {
        this.errorCode = validateErrorCode(errorCode);
        this.stackTrace = stackTrace || new Error('CONSUMER_ERROR_PAYLOAD_STACKTRACE_UNAVAILABLE');
    }
}

export default ConsumerErrorPayload;
